import { FileText } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { InvestorDocumentFolders } from '@/components/documents/InvestorDocumentFolders';

interface InvestorDocumentsFormProps {
  investorId?: string;
  investorName: string;
}

export function InvestorDocumentsForm({
  investorId,
  investorName,
}: InvestorDocumentsFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Documents & Files</CardTitle>
        <CardDescription>
          General documents, and one folder per fund
        </CardDescription>
      </CardHeader>
      <CardContent>
        {investorId && investorName ? (
          <InvestorDocumentFolders
            investorId={investorId}
            investorName={investorName}
          />
        ) : (
          <div className="text-center py-12 text-gray-500">
            <FileText className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>Save the investor first to manage documents</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
